






































































import Vue from 'vue'
import WrappedLink from '@components/WrappedLink.vue'
export default Vue.extend({
  name: 'Footer',
  components: {
    WrappedLink
  }
})
